import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useLocalStorage } from "../../context/useLocalStorage";
import localStorageKey from "../../enumerations/localStorageKey";
import { useGetCoaches } from "../../hooks/Coach/coach.hooks";
import { Banner, FilterBar, PromotionBanner, Slogan } from "./components";
import CoachHot from "./components/CoachHot";
import styles from "./styleModule";

const Home: React.FC = () => {
  const { data: coaches } = useGetCoaches({ limit: 10 }, {});
  const [searchParams] = useSearchParams();
  const [, setCoupon] = useLocalStorage(localStorageKey.COUPON, undefined);

  useEffect(() => {
    // 獲取特定查詢參數
    const coupon = searchParams.get("coupon_code");
    if (!coupon) return;
    console.debug("coupon", coupon);
    setCoupon({ data: coupon, time: Date.now() + 1000 * 60 * 60 * 24 * 7 });
  }, []);

  return (
    <div className={styles.homeContainer}>
      <div className={styles.bannerContainer}>
        <Banner />
        <FilterBar />
        <Slogan />
      </div>
      <PromotionBanner />
      <CoachHot coaches={coaches} />
    </div>
  );
};

export default Home;
